export function getText(html) {
  var divContainer = document.createElement("div");
  divContainer.innerHTML = html;
  // Truy cập tất cả các thẻ <br> và thay thế chúng bằng dòng mới (\n)
  const brElements = divContainer.querySelectorAll("br");
  brElements.forEach((br) => {
    const textNode = document.createTextNode("\n");
    br.parentNode.replaceChild(textNode, br);
  });

  // Lấy nội dung đã thay thế
  return divContainer.textContent || divContainer.innerText || "";
}
